<form class="space-y-3 sm:space-y-4 w-full max-w-full" (submit)="guardar($event)">
	<div>
		<label class="block text-sm font-medium text-gray-700">Nombre</label>
		<input [formField]="$any(formPromocion.nombre)" class="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500" />
	</div>

	<div>
		<label class="block text-sm font-medium text-gray-700">Contenido (HTML)</label>
		<textarea [formField]="$any(formPromocion.contenido)" class="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 font-mono" rows="5" placeholder="Usa <qr>URL</qr> para insertar códigos QR."></textarea>
		<p class="text-xs text-gray-400 mt-1">Usa <code>&lt;qr&gt;URL&lt;/qr&gt;</code> para insertar códigos QR.</p>
	</div>

	<div class="grid grid-cols-1 sm:grid-cols-2 gap-3">
		<div>
			<label class="block text-sm font-medium text-gray-700">Tipo de documento</label>
			<app-select
				[filter]="true"
				filterBy="label,value"
				emptyFilterMessage="No se encontraron tipos."
				[formField]="$any(formPromocion.tipo_documento)"
				[options]="opcionesTipoDocumento()"
				[loading]="!opcionesTipoDocumento().length"
				class="w-full"
			/>
		</div>
		<div>
			<label class="block text-sm font-medium text-gray-700">Monto mínimo (opcional)</label>
			<input type="number" [formField]="$any(formPromocion.monto_minimo)" class="w-full text-sm border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500" step="0.01" />
		</div>
	</div>

	<div class="flex items-center gap-2">
		<input type="checkbox" [formField]="$any(formPromocion.activo)" class="h-4 w-4 rounded border-gray-300 accent-blue-600 cursor-pointer" />
		<label class="text-sm font-medium text-gray-700">Activo</label>
	</div>

	<div class="flex justify-end gap-2 pt-4">
		<button type="button" class="px-4 py-2 rounded-lg bg-gray-100 text-gray-700 hover:bg-gray-200 font-medium" (click)="cancelar()">
			Cancelar
		</button>
		<button type="submit" class="px-4 py-2 rounded-lg bg-blue-600 text-white hover:bg-blue-700 font-medium">
			Guardar
		</button>
	</div>
</form>
